<div class="agpr-emailRecipient">
    <div class="agpr-emailRecipient-filterToolbar">
        <div class="agpr-emailRecipient-filterToolbar-filterInput">
            <agpr-filter-dropdown
                id="resultsFilters"
                [showQuickFilter]="true"
                quickFilterPlaceholder="Discover.targeting.filter.email.placeholder"
                [ariaLabel]="'Discover.distribution.recipients.email.filterLabel' | localize"
                ariaDescribedBy="staffSearch.chips"
            ></agpr-filter-dropdown>
        </div>
        <agpr-sort-order
            id="emailRecipientSortOrder"
            class="agpr-emailRecipient-filterToolbar-sortOrder"
            [isDisabled]="!results?.length"
            tooltip="Discover.targeting.tooltips.sort"
            optionKey="enumValue"
            optionLabel="displayString"
        ></agpr-sort-order>
    </div>
    <agpr-filter-chips
        class="agpr-emailRecipient-filterChips"
        *ngIf="chipsVisible"
        id="staffSearch.chips"
    ></agpr-filter-chips>

    <div class="agpr-emailRecipient-totalCount">
        <span class="agpr-emailRecipient-totalCount-value">
                {{ totalResults || '0'}}
                <span class="agpr-emailRecipient-totalCount-text">
                    {{'Briefings.recipients' | localize}}
                </span>
        </span>
        <agpr-minimal-paginator [isDisabled]="!totalResults"></agpr-minimal-paginator>
    </div>
</div>
